import { render, staticRenderFns } from "./brandEvaluation.vue?vue&type=template&id=6179e2c5&scoped=true&"
import script from "./brandEvaluation.vue?vue&type=script&lang=js&"
export * from "./brandEvaluation.vue?vue&type=script&lang=js&"
import style0 from "./brandEvaluation.vue?vue&type=style&index=0&id=6179e2c5&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6179e2c5",
  null
  
)

export default component.exports